import { render, staticRenderFns } from "./zoom-config.vue?vue&type=template&id=45a7fa7c&"
import script from "./zoom-config.vue?vue&type=script&lang=js&"
export * from "./zoom-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports